/* eslint-disable import/no-cycle */
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { AppState } from "../store/store.type";

interface cartItem {
	id: string;
	name: string;
	filePath: string | null;
	price: number;
	quantityOrdered?: number;
	size?: "S" | "M" | "L";
	quantity?: number;
}

const initialState: any = [];

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state: cartItem[], action: PayloadAction<cartItem>) => {
      const item = state.find(
        (item) =>
          item.id === action.payload.id
      );
      if (item) {
        item.quantityOrdered
          ? (item.quantityOrdered += Number(action.payload.quantityOrdered))
          : (item.quantityOrdered =
              Number(action.payload.quantityOrdered) || 1);
        item.price = item.price * item.quantityOrdered;
      } else {
        state.push(action.payload);
      }
    },
    removeFromCart: (state: cartItem[], action: PayloadAction<string>) => {
      return state.filter((item) => item.id !== action.payload);
    },
    clearCart: () => {
      return initialState;
    },
    incrementQuantity: (state: cartItem[], action: PayloadAction<string>) => {
      const item = state.find((item) => item.id === action.payload);
      if (item) {
        item.quantityOrdered
          ? item.quantityOrdered++
          : (item.quantityOrdered = 1);
      }
    },
    decrementQuantity: (state: cartItem[], action: PayloadAction<string>) => {
      const item = state.find((item) => item.id === action.payload);
      if (item && item.quantityOrdered && item.quantityOrdered > 1) {
        item.quantityOrdered
          ? item.quantityOrdered--
          : (item.quantityOrdered = 1);
      }
    },
    changeSize: (state: cartItem[], action: PayloadAction<cartItem>) => {
      const item = state.find((item) => item.id === action.payload.id);
      if (item) {
        item.size = action.payload.size;
      }
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  clearCart,
  incrementQuantity,
  decrementQuantity,
} = cartSlice.actions;

// Selectors
export const selectCart = (state: AppState) => state.cart;

export default cartSlice.reducer;
